<div
  [ngClass]="
    showSummary()
      ? 'flex flex-col-reverse gap-8 md:flex-row'
      : 'max-w-4xl mx-auto'
  "
>
  <div
    [ngClass]="
      showSummary()
        ? 'flex flex-grow flex-col gap-4 md:w-1/2 lg:w-3/5'
        : 'w-full'
    "
  >
    <div
      class="flex flex-col gap-8 rounded-2xl border border-secondary-border bg-white p-8"
    >
      <div class="flex flex-col gap-3 border-b border-secondary-border pb-6">
        @if (eyebrowKey(); as eyebrowKey) {
          <p
            class="text-sm font-medium tracking-wide text-secondary-text uppercase"
          >
            {{ eyebrowKey | translate }}
          </p>
        }

        <h1 class="text-3xl leading-tight font-medium text-primary-text">
          {{ titleKey() | translate }}
        </h1>
        @if (descriptionKey(); as descriptionKey) {
          <p class="text-base text-secondary-text">
            {{ descriptionKey | translate }}
          </p>
        }
      </div>

      @if (noticeKey(); as noticeKey) {
        <p class="text-sm text-primary-text">
          {{ noticeKey | translate }}
        </p>
      }

      <ng-content></ng-content>
    </div>
  </div>

  @if (showSummary()) {
    <div class="w-full md:w-1/2 lg:w-2/5">
      <dhp-article-purchase-summary-card></dhp-article-purchase-summary-card>
    </div>
  }
</div>
